/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Tool usage user identity kind
 */
export const ToolUsageUserFilterKind = {
  Email: "email",
  ExternalUserId: "external_user_id",
  UserId: "user_id",
  AgentId: "agent_id",
  Unknown: "unknown",
} as const;
/**
 * Tool usage user identity kind
 */
export type ToolUsageUserFilterKind = ClosedEnum<
  typeof ToolUsageUserFilterKind
>;

/**
 * Typed user identity filter
 */
export type ToolUsageUserFilter = {
  /**
   * User identity value to include
   */
  key: string;
  /**
   * Tool usage user identity kind
   */
  kind: ToolUsageUserFilterKind;
};

/** @internal */
export const ToolUsageUserFilterKind$outboundSchema: z.ZodMiniEnum<
  typeof ToolUsageUserFilterKind
> = z.enum(ToolUsageUserFilterKind);

/** @internal */
export type ToolUsageUserFilter$Outbound = {
  key: string;
  kind: string;
};

/** @internal */
export const ToolUsageUserFilter$outboundSchema: z.ZodMiniType<
  ToolUsageUserFilter$Outbound,
  ToolUsageUserFilter
> = z.object({
  key: z.string(),
  kind: ToolUsageUserFilterKind$outboundSchema,
});

export function toolUsageUserFilterToJSON(
  toolUsageUserFilter: ToolUsageUserFilter,
): string {
  return JSON.stringify(
    ToolUsageUserFilter$outboundSchema.parse(toolUsageUserFilter),
  );
}
